/* eslint-disable import/no-default-export, import/order, max-lines, max-lines-per-function, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import { useRef, useState, useEffect, useImperativeHandle } from "react";
import { REDRAW_NOTES_MAX_LENGTH } from "common/redraw-constants";
import { isMediumDeviceAndUp } from "common/utils/browser";
import { submitDtfEvent } from "common/utils/mixpanel/submit-dtf-events";
import { cn } from "tailwind-variants";
import CommonModal from "common/vue/components/CommonModal.react.vue";
import Tooltip from "common/vue/components/Tooltip.react.vue";
import { EventBus, Events } from "jiffy-store";
import debounce from "lodash.debounce";
import CustomNotes from "./ArtworkQualityConfigPanel/components/CustomNotes.vue";
import RedrawInformation from "./Modals/RedrawInformation.vue";
import PinningSessionEntry from "./PinningSession/PinningSessionEntry.vue";
import { useDtfStore } from "./store";
import "./RedrawNotes.scss";

function RedrawNotes({
  ref,
  index = 0,
  enhancementNote = undefined,
  isMultiUpload = false,
  disabled = false,
  onLearnMore = null,
  // @ts-expect-error TS(6133): 'restProps' is declared but its value is never rea... Remove this comment to see the full error message
  ...restProps
}: any) {
  const [note, setNote] = useState("");
  const [isOpenRedrawInformationModal, setIsOpenRedrawInformationModal] = useState(false);
  // @ts-expect-error TS(6133): 'setIsMobile' is declared but its value is never r... Remove this comment to see the full error message
  const [isMobile, setIsMobile] = useState(!isMediumDeviceAndUp());
  const [pricingRefreshTimeout, setPricingRefreshTimeout] = useState(null);
  const [previousNoteValue, setPreviousNoteValue] = useState("");

  const textareaRef = useRef(null);
  const redrawInformationTooltipRef = useRef(null);
  const redrawInformationModalRef = useRef(null);

  const dtfStore = useDtfStore();

  function isStandardArtwork() {
    // @ts-expect-error TS(4111): Property 'isStandardArtwork' comes from an index s... Remove this comment to see the full error message
    return dtfStore.isStandardArtwork;
  }

  // @ts-expect-error TS(6133): 'experiments' is declared but its value is never r... Remove this comment to see the full error message
  function experiments() {
    // @ts-expect-error TS(4111): Property 'experiments' comes from an index signatu... Remove this comment to see the full error message
    return dtfStore.experiments;
  }

  function enableAbAiMonetization() {
    // @ts-expect-error TS(4111): Property 'enableAbAiMonetization' comes from an in... Remove this comment to see the full error message
    return dtfStore.enableAbAiMonetization;
  }

  // @ts-expect-error TS(6133): 'isJiffyMade' is declared but its value is never r... Remove this comment to see the full error message
  function isJiffyMade() {
    // @ts-expect-error TS(4111): Property 'isJiffyMade' comes from an index signatu... Remove this comment to see the full error message
    return dtfStore.isJiffyMade;
  }

  function showDesignServicesDeliveryBuffer() {
    // @ts-expect-error TS(4111): Property 'showDesignServicesDeliveryBuffer' comes ... Remove this comment to see the full error message
    return dtfStore.showDesignServicesDeliveryBuffer;
  }

  function isPinBasedRedrawEnabled() {
    // @ts-expect-error TS(4111): Property 'isPinBasedRedrawEnabled' comes from an i... Remove this comment to see the full error message
    return dtfStore.isPinBasedRedrawEnabled;
  }

  function artworks() {
    // @ts-expect-error TS(4111): Property 'artworks' comes from an index signature,... Remove this comment to see the full error message
    return dtfStore.artworks;
  }

  function showPinningSessionEntry() {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    const artwork = artworks()[index];
    return artwork && (isPinBasedRedrawEnabled() || artwork.pinningSessionId);
  }

  function updateArtworkValues(...args: any[]) {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return dtfStore.updateArtworkValues(...args);
  }

  function getArtworksPricing(...args: any[]) {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return dtfStore.getArtworksPricing(...args);
  }

  function updatePdpDates(...args: any[]) {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return dtfStore.updatePdpDates(...args);
  }

  const debouncedUpdatePdpDates = useRef(
    debounce(() => {
      updatePdpDates();
    }, 500)
  ).current;

  const debouncedSubmitNoteChangedEvent = useRef(
    debounce(noteValue => {
      submitDtfEvent("dtf_need_artist_edits_note_changed", {
        page: "pdp",
        artwork_index: index,
        note_value: noteValue,
        note_length: noteValue.length
      });
    }, 500)
  ).current;

  function saveNote(e: any) {
    const noteValue = (e.target.value ?? "").trim();
    updateArtworkValues({
      index,
      enhancementNote: noteValue
    });
    if (noteValue !== previousNoteValue) {
      debouncedSubmitNoteChangedEvent(noteValue);
    }
    if (showDesignServicesDeliveryBuffer()) {
      const hadContent = !!previousNoteValue;
      const hasContent = !!noteValue;
      if (hasContent || (hadContent && !hasContent)) {
        debouncedUpdatePdpDates();
      }
    }
    setPreviousNoteValue(noteValue);
    // Debounce pricing refresh to avoid excessive API calls
    // @ts-expect-error TS(2345): Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
    clearTimeout(pricingRefreshTimeout);
    const timeout = setTimeout(() => {
      getArtworksPricing();
    }, 500);
    // @ts-expect-error TS(2345): Argument of type 'number' is not assignable to par... Remove this comment to see the full error message
    setPricingRefreshTimeout(timeout);
  }

  function openRedrawInformationModal() {
    submitDtfEvent("redraw_information_modal_opened", {
      page: "pdp"
    });
    if (isMobile) {
      setIsOpenRedrawInformationModal(true);
    }
  }

  function closeRedrawInformationModal() {
    // @ts-expect-error TS(2339): Property 'close' does not exist on type 'never'.
    redrawInformationModalRef.current?.close();
    setIsOpenRedrawInformationModal(false);
  }

  function closeRedrawInformationTooltip() {
    // @ts-expect-error TS(2339): Property 'hideTooltip' does not exist on type 'nev... Remove this comment to see the full error message
    redrawInformationTooltipRef.current?.hideTooltip();
  }

  function focusTextarea() {
    if (textareaRef.current) {
      // @ts-expect-error TS(2339): Property 'focus' does not exist on type 'never'.
      textareaRef.current.focus();
      // @ts-expect-error TS(2339): Property 'scrollIntoView' does not exist on type '... Remove this comment to see the full error message
      textareaRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center"
      });
    }
  }

  useImperativeHandle(ref, () => ({
    focusTextarea
  }));

  useEffect(() => {
    setNote(enhancementNote ?? "");
    setPreviousNoteValue(enhancementNote ?? "");

    const handleItemsAdded = () => {
      setNote("");
    };

    EventBus.on(Events.ITEMS_ADDED_TO_CART, handleItemsAdded);

    return () => {
      EventBus.removeEventListener(Events.ITEMS_ADDED_TO_CART, handleItemsAdded);
      if (debouncedUpdatePdpDates) {
        debouncedUpdatePdpDates.cancel();
      }
      if (debouncedSubmitNoteChangedEvent) {
        debouncedSubmitNoteChangedEvent.flush();
        debouncedSubmitNoteChangedEvent.cancel();
      }
      if (pricingRefreshTimeout) {
        clearTimeout(pricingRefreshTimeout);
      }
    };
  }, [enhancementNote]);

  return (
    <>
      {showPinningSessionEntry() ? (
        <PinningSessionEntry
          className={cn("scope-aee006ff", {
            "pt-5": !isStandardArtwork(),
            "mb-5": isMultiUpload
          })}
          index={index}
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          artwork={artworks()[index]}
          data-testid="pinning-session-entry"
        />
      ) : isStandardArtwork() && enableAbAiMonetization() ? (
        <CustomNotes
          className="scope-aee006ff"
          modelValue={note}
          onUpdateModelValue={(val: any) => {
            setNote(val);
          }}
          disabled={disabled}
          onLearnMore={onLearnMore}
          index={index}
          onInput={saveNote}
          data-testid="custom-notes"
        />
      ) : (
        <div
          className={cn("redraw-notes scope-aee006ff", {
            "redraw-notes--multi-upload": isMultiUpload,
            "redraw-notes--standard-artwork": isStandardArtwork()
          })}
        >
          <label
            className="redraw-notes__label scope-aee006ff"
            htmlFor={`redraw-note-${index}`}
            data-testid="redraw-notes-label"
          >
            <span className="redraw-notes__label-text scope-aee006ff">
              <span className="scope-aee006ff">
                <strong className="scope-aee006ff">Free</strong> optional design editing included
              </span>
              <span className="scope-aee006ff">
                (a <strong className="scope-aee006ff">$10</strong> value)!
              </span>
            </span>
            <Tooltip
              className="scope-aee006ff"
              ref={redrawInformationTooltipRef}
              disabled={isMobile}
              trigger="click"
              position="bottom-right"
              slots={{
                target: () => (
                  <button
                    className={cn("redraw-notes__how-it-works scope-aee006ff", {
                      "redraw-notes__how-it-works--standard-artwork": isStandardArtwork()
                    })}
                    type="button"
                    onClick={openRedrawInformationModal}
                    data-testid="redraw-notes-how-it-works"
                  >
                    {" "}
                    How it works{" "}
                  </button>
                ),

                content: () => (
                  <RedrawInformation
                    className="scope-aee006ff"
                    isMobile={false}
                    onClose={closeRedrawInformationTooltip}
                    data-testid="redraw-information"
                  />
                )
              }}
              data-testid="tooltip"
            />
          </label>
          <textarea
            className="redraw-notes__textarea scope-aee006ff"
            id={`redraw-note-${index}`}
            ref={textareaRef}
            value={note}
            onChange={e => {
              setNote(e.target.value);
              saveNote(e);
            }}
            maxLength={REDRAW_NOTES_MAX_LENGTH}
            placeholder="e.g. Keep the white inside of the text. Change the letters of the logo to orange."
            data-testid="redraw-notes-textarea"
          />

          {showDesignServicesDeliveryBuffer() ? (
            <label
              className="redraw-notes__note redraw-notes__note--delivery scope-aee006ff"
              data-testid="redraw-notes-note"
            >
              {" "}
              Design Services add 1 day to delivery.{" "}
            </label>
          ) : null}
        </div>
      )}
      {isMobile && isOpenRedrawInformationModal ? (
        <CommonModal
          className="scope-aee006ff"
          ref={redrawInformationModalRef}
          compact={true}
          hideCloseButton={true}
          bottomAligned={true}
          onOnClose={closeRedrawInformationModal}
          data-testid="common-modal"
        >
          <RedrawInformation
            className="scope-aee006ff"
            isMobile={true}
            onClose={closeRedrawInformationModal}
            data-testid="redraw-information-1"
          />
        </CommonModal>
      ) : null}
    </>
  );
}

RedrawNotes.displayName = "RedrawNotes";

export default RedrawNotes;
